import { MIN_LENGTH_FOR_NSN as v, PLUS_CHARS as T$1, VALID_PUNCTUATION as N, VALID_DIGITS as _ } from './contact-channels197.js';
import D from './contact-channels218.js';

var n="["+_+"]{"+v+"}",I="["+T$1+"]{0,1}(?:["+N+"]*["+_+"]){3,}["+N+_+"]*",P=new RegExp("^["+T$1+"]{0,1}(?:["+N+"]*["+_+"]){1,2}$","i"),R=I+"(?:"+D()+")?",T=new RegExp("^"+n+"$|^"+R+"$","i");function A(N){return N.length>=v&&T.test(N)}function o(N){return P.test(N)}

export { I as VALID_PHONE_NUMBER, R as VALID_PHONE_NUMBER_WITH_EXTENSION, A as default, o as isViablePhoneNumberStart };
//# sourceMappingURL=contact-channels221.js.map
